import type { ActivityDockPointerHandlers } from "@/components/activity/useActivityDockTapVsDrag";
import { DockFireflyInSidebarButton } from "@/components/activity/DockFireflyInSidebarButton";

export function ActivityDockPanelHeader(props: {
  panelDragHandlers?: ActivityDockPointerHandlers;
  showStopBlinking: boolean;
  onStopBlinking?: () => void;
  onClose: () => void;
}) {
  return (
    <>
      {props.showStopBlinking && props.onStopBlinking ? (
        <div className="mb-2 flex justify-center">
          <button
            type="button"
            onClick={props.onStopBlinking}
            className="rounded-full border border-red-300 bg-red-50 px-3 py-1 text-[11px] font-semibold text-red-800 shadow-sm hover:bg-red-100 dark:border-red-500/50 dark:bg-red-950/40 dark:text-red-100 dark:hover:bg-red-950/60"
          >
            Calm Firefly
          </button>
        </div>
      ) : null}
      <div className="mb-2 flex items-center justify-between gap-2">
        <div
          className={[
            "min-w-0 flex-1",
            props.panelDragHandlers ? "cursor-grab touch-none active:cursor-grabbing" : "",
          ].join(" ")}
          {...(props.panelDragHandlers ?? {})}
        >
          <h2 className="text-sm font-semibold text-gray-900 dark:text-gray-50">Activity</h2>
          <p className="text-[11px] text-gray-500 dark:text-gray-400">
            Goals, messages, and Firefly tools.
          </p>
        </div>
        <div className="flex shrink-0 items-center gap-1">
          <DockFireflyInSidebarButton onAfterDock={props.onClose} />
          <button
            type="button"
            onClick={props.onClose}
            aria-label="Close activity panel"
            className="-mr-1 -mt-1 inline-flex h-7 w-7 items-center justify-center rounded-full text-gray-400 hover:bg-gray-100 hover:text-gray-700 dark:hover:bg-zinc-800 dark:hover:text-gray-200"
          >
            ×
          </button>
        </div>
      </div>
    </>
  );
}
